import React from 'react';
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import MonthYearInput from "../../../../components/reports/month-year-input/month-year-input.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({setFilters, filters}) => {
    const { corporationActionsTeam } = useReportFiltersFetch({ fetchCorporationActionsTeam: true })

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                     <MonthYearInput filters={filters} setFilters={setFilters}/>

                     <SelectComponent
                         id="type"
                         label='Tipo de análise *'
                         isMulti={false}
                         wrapValues={true}
                         options={[
                             {label: "Resumida", value: 'resumed'},
                             {label: "Detalhada", value: 'detailed'}
                         ]}
                         value={filters.type}
                         onChange={(value) => setFilters(prev => ({...prev, type: value}))}
                         classNameWrapper={"w-full"}
                         isClearable={false}
                     />

                     <SelectComponent
                         id="team"
                         label='Equipe'
                         isMulti={true}
                         wrapValues={true}
                         options={corporationActionsTeam}
                         value={filters.team}
                         onChange={(value) => setFilters(prev => ({...prev, team: value}))}
                         classNameWrapper={"w-full"}
                     />

                </form>
            </div>
        </>
    );
};

export default Filters;